import VueRouter from "vue-router";
import Vue from "vue";
import StartComponent from "./components/pages/StartComponent.vue";
import TextPage from "./components/pages/TextPageComponent.vue";

const routes = [
	{path: "/", component: StartComponent},
	{path: "/angebote", component: TextPage },
	{path: "/career", component: TextPage },
	{path: "/unternehmen", component: TextPage },
	{path: "/impressum", component: TextPage },
	{path: "/datenschutz", component: TextPage },
	{path: "/arbeiten-bei-manitz-it", component: TextPage},
]

export default new VueRouter({
	routes,
})

Vue.use(VueRouter)